//
//
//
//
//
//

export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        iconclass: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: null,
        },
        fill: {
            type: String,
            default: null,
        },
        align: {
            type: [Boolean, String],
            default: false,
        },
        stroke: {
            type: Boolean,
            default: false,
        },
        strokeOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {string} */
        fontSize() {
            return this.size ? `font-size-${this.size}` : '';
        },
        /** @return {string | undefined} */
        textAlign() {
            if (!this.align) {
                return;
            }

            if (this.align === true) {
                return this.align && this.size ? `text-align-${this.size}` : '';
            }

            return `text-align-${this.align}`;
        },
        /** @return {object?} */
        iconFill() {
            return this.fill ? { color: this.fill } : null;
        },
        /** @return {string?} */
        iconStroke() {
            if (!this.strokeOnly && !this.stroke) {
                return null;
            }

            return this.stroke ? 'tidal-icon--stroke' : 'tidal-icon--stroke-only';
        },
    },
};
